/* eslint eqeqeq: 0 */

import React, { useEffect } from 'react'
import { useParams } from "react-router-dom"
import { motion } from "framer-motion";

import Hero from '../components/Hero'
import Header from '../components/Header'
import WorkPresentation from '../components/WorkPresentation'
import WorkGallery from '../components/WorkGallery'
import WorkNextPD21 from '../components/WorkNextPD21'

import Works from '../data/WorksPD2021';
import Footer from '../components/Footer';
import BackHome from '../elements/BackHome';

function SingleWork() {

    const LoadingTransition = { duration: 1, ease: [0.43, 0.13, 0.23, 0.96] };

    useEffect(() => {
        const headerAnim = document.querySelector('.header-anim')
        const heroTitle = document.querySelectorAll('.hero-title')
        const bgImg = document.querySelector('.single-project-hero')
        
        setTimeout(() => {
            bgImg.classList.add('single-project-hero-on')
        }, 1000)

        setTimeout(() => {
            headerAnim.classList.add('header-anim-on')
        }, 1500)

        setTimeout(() => {
            heroTitle.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('hero-title-on')
                }, 200 * index) 
            })
        }, 2000)
    }, [])

    const onScrollBottomAnim = () => {
        const animBot = document.querySelectorAll('.anim-bot')

        animBot.forEach(item => {
            let itemPosition = item.getBoundingClientRect();

            if(itemPosition.top >= 0 && itemPosition.top <= window.innerHeight - 80) {
                item.classList.add('item-anim-bot')
            }
        })   
    }

    useEffect(() => {
        window.addEventListener("scroll", onScrollBottomAnim);
        return () => window.removeEventListener("scroll", onScrollBottomAnim);
    }, [])
    
    const {workId} = useParams()
    const thisWork = Works.find(element => element.id == workId)

    return(
        <div>
            <motion.div 
                initial={{x:0}}
                animate={{x:'-100%'}}
                exit={{x:0}}
                transition={LoadingTransition}
                className="page-trans">
            </motion.div>
            <Header />
            <Hero background={thisWork.background} class='single-project-hero' tint='dark-bg'>
                <h6 className="sub-title hero-title">{thisWork.category}</h6>
                <h1 className="big-title hero-title">{thisWork.name}</h1>
                <h2 className="hero-title">{thisWork.author}</h2>
            </ Hero>
            <WorkPresentation presentationImage = {thisWork.presentationImage} />
            <WorkGallery galleryImage = {thisWork.galleryImage} />    
            <WorkNextPD21 link={thisWork.id < Works.length ? thisWork.id + 1 : thisWork.id } noMore={thisWork.id == Works.length && 'done'}/>
            
            <BackHome />

            <Footer />
        </div>
    )

}

export default SingleWork